module.exports = function getResource(label, vars = []) {
    let resources = {
        reservationDetails: 'Reservation Details',
        pickupLocation: 'Pickup Location',
        contactInformation: 'Contact Information',
        storeDetails: 'Store Details'
    };

    return resources[label];
};
